(function(){

"use strict";

angular.module('swapick.constants', [])

.run(function(){})

.config(function(){})

//#TODO:change me in production
//.constant('baseServerUrl', "/swapick_api")

.constant('baseServerUrl',
    (()=>{
    // return "https://swapick.com"
    return "https://swapick.sandbox.inmagik.com/api"
    
    if(window.cordova){
        return "https://api.swapick.com";
        return "http://45.32.153.130";
    }
    return "/swapick_api";
})())

.constant('clientId', '1_4qf390tgjwo40k088s8sw4gk8gwgcs8w0ccswwok84cko80os8')
.constant('clientSecret', '62lr2d8w56w44k4s0gs8gsg0k0wsc4s804ck0880g80o408c4c')
.constant('$ionicLoadingConfig', {
  template: '<ion-spinner class="spinner-positive" icon="spiral"></ion-spinner>'
})
.constant('appVersion', 'alpha 0.2')



})();



// WEBPACK FOOTER //
// ./src/config/constants-config.js